import { errors } from "../../constants";
import { TestResolver } from "../../models";
import { isDateBeforeToday, isISODateStr } from "../date.helpers";

export const notInThePast: TestResolver = ({
  context,
  value,
  errorMessage,
  timezone,
}) => {
  if (!value) {
    return true;
  }

  // Reported separately from the past-date message: a typo such as O instead of 0 is an unparseable date, and telling
  // the user it "cannot be in the past" would be misleading.
  if (typeof value !== "string" || !isISODateStr(value)) {
    return context.createError({ message: errors.validation.dateIsInvalid });
  }

  // Without the company timezone the day boundary cannot be resolved, so skip rather than guess at it.
  if (!timezone || !isDateBeforeToday(value, timezone)) {
    return true;
  }

  return context.createError({ message: errorMessage });
};
